<template>
  <LegacyPageContent v-if="hasProfile">
    <v-row
      no-gutters
      align="center"
      class="mb-2"
    >
      <v-col cols="auto">
        <div class="headline">
          Connections
          <InfoIcon @onClick="handleInfoIconClick" />
        </div>
      </v-col>

      <v-spacer />

      <!-- <v-col class="text-right">
        <v-btn
          rounded
          color="primary"
          dark
          small
          @click="connDialog"
        >
          Invite to network
        </v-btn>
      </v-col> -->
    </v-row>
  
    <MyConnections class="py-3" />

    <v-row no-gutters>
      <v-tabs
        grow
        v-model="activeTab"
        class="mb-3"
        @change="handleTabsChange"
      >
        <v-tab
          href="#connections"
          class="ml-0"
        >
          Connections&nbsp;({{ connectionsTotal || '' }})
        </v-tab>

        <v-tab href="#network">
          Network&nbsp;({{ usersTotal || '' }})
        </v-tab>

        <v-tab
          href="#invites"
          :disabled="!incomingInvites.length"
        >
          Invites&nbsp;({{ incomingInvitesTotal || '' }})
        </v-tab>
      </v-tabs>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <v-tabs-items v-model="activeTab">
          <v-tab-item value="connections">
            <SearchField
              label="your connections"
              :search="searchField.connections"
              :tab="activeTab"
              class="mt-1"
              @searching="handleSearch('connections', $event)"
            />

            <v-row
              align="center"
              class="my-2"
            >
              <v-col
                cols="12"
                md="auto"
                lg="auto"
                xl="auto"
              >
                <v-btn
                  rounded
                  color="primary"
                  dark
                  small
                  @click="handleInviteToNetworkClick"
                >
                  Invite to network
                </v-btn>
              </v-col>
              <!-- <v-col>
                If anyone you refer to the network is staffed by Riverflex you will receive a referral bonus of £1000 or €1000 (see T&Cs)
              </v-col> -->
            </v-row>

            <!-- <v-row v-if="!connections || connections.length === 0">
              <v-col class="text-center">
                <v-btn
                  rounded
                  color="primary"
                  dark
                  @click="connDialog"
                >
                  Invite your network
                </v-btn>
              </v-col>
            </v-row> -->
            <listConnections
              :items="connections"
              :option="{ type: 'connections' }"
              :total="connectionsTotal"
              :page="pagination.connections.page"
              :is-fetching-more="pagination.connections.isFetching"
              :is-searching="isSearching('connections')"
              @showUser="handleShowViewProfileDialog"
              @fetchMore="handleFetchMore('connections', $event)"
            />
          </v-tab-item>

          <v-tab-item value="network">
            <template v-if="canSeeUsersNetwork">
              <SearchField
                label="entire network"
                :search="searchField.users"
                :tab="activeTab"
                class="mt-1"
                @searching="handleSearch('users', $event)"
              />

              <listConnections
                :items="users"
                :option="{ type: 'network' }"
                :total="usersTotal"
                :page="pagination.users.page"
                :is-fetching-more="pagination.users.isFetching"
                :is-searching="isSearching('users')"
                @createInvite="createInvite"
                @showUser="handleShowViewProfileDialog"
                @fetchMore="handleFetchMore('users', $event)"
              />
            </template>
            <div
              class="px-2 member-warning-wrap"
              v-else
            >
              <p class="text-center mt-4 primary--text font-weight-bold">
                In order to access the rest of the network, please add an up to date CV to your profile.<br>This enables us to continually curate the quality of our network.<br> You can add your CV in your <router-link
                  class="purple--text"
                  to="/profile"
                >
                  profile view
                </router-link>
              </p>
              <!-- <p class="text-center mt-2 primary--text font-weight-bold">
                In order to see other members of the Riverflex network, you must be a&nbsp;
                <span class="secondary--text">Riverflex Insider</span>
              </p>

              <p class="text-center mt-2 primary--text font-weight-bold">
                As we have not yet verified your profile through interview, you are considered a&nbsp;
                <span class="purple--text">Riverflex Member</span>
              </p>

              <p class="text-center mb-0 primary--text font-weight-bold">
                How do I become an Insider?
              </p>
              <ul>
                <li>
                  If the Riverflex team believe your profile is a good match to our clients' needs, we will invite you to an Insider interview
                </li>
                <li class="text-wrap">
                  Completing your profile increases your chance to be invited
                </li>
              </ul>

              <p class="text-center mt-3 primary--text font-weight-bold">
                <span class="purple--text">Riverflex Members</span> can still enjoy other features of our application &mdash; why not check out our open opportunities?
              </p> -->
            </div>
          </v-tab-item>

          <v-tab-item value="invites">
            <SearchField
              label="pending invites"
              :search="searchField.incomingInvites"
              :tab="activeTab"
              class="mt-1"
              @searching="handleSearch('incomingInvites', $event)"
            />

            <listConnections
              v-if="incomingInvites"
              :items="incomingInvites"
              :option="{ type: 'invites' }"
              :total="incomingInvitesTotal"
              :page="pagination.incomingInvites.page"
              :is-fetching-more="pagination.incomingInvites.isFetching"
              :is-searching="isSearching('incomingInvites')"
              @showUser="handleShowViewProfileDialog"
              @acceptInvite="acceptInvite"
              @declineInvite="declineInvite"
              @fetchMore="handleFetchMore('incomingInvites', $event)"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-dialog
      v-model="addConnectionDialog"
      :retain-focus="false"
      transition="slide-y-transition"
    >
      <addConnection
        :show-more-info="false"
        @hide="addConnectionDialog = false"
        @moreInfoClick="showReferContactDialog = false"
      />
    </v-dialog>

    <UserProfileDialog
      :show="viewProfileDialog"
      :profile="selectedUser"
      @hide="handleHideViewProfileDialog"
    />
    <InfoDialog
      title="Start building connections"
      :show.sync="showInfoDialog"
    >
      <div>
        <p>
          Build connections and tap into your private network to help you find and share unique consulting opportunities.
        </p>
        <p>
          Grow the community by inviting peers who are not yet part of the platform so they can also share and receive* opportunities.
        </p>
        <!-- <p>
          <i>
            * You will also be rewarded if you invite a new member to the network and they are engaged on a Riverflex project see the Rewards screen for info
          </i>
        </p> -->
      </div>
    </InfoDialog>
    <ReferContactRewardsDialog
      :show="showReferContactDialog"
      :show-refer-contact-btn="false"
      @hide="showReferContactDialog = false"
    />
  </LegacyPageContent>
</template>
<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator'
import { IDebouncedFunction, debounce } from 'debounce'
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave'
])

import MyConnections from '@/components/profile/MyConnections.vue'
import SearchField from '@/components/core/SearchFieldConnection.vue'
import listConnections from '@/components/connections/ListConnections.vue'
import addConnection from '@/components/connections/AddConnection.vue'
import UserProfileDialog from '@/components/profile/UserProfileDialog.vue'
import InfoDialog from '@/components/core/InfoDialog.vue'
import InfoIcon from '@/components/core/InfoIcon.vue'
import LegacyPageContent from '@/components/layouts/LegacyPageContent.vue'

import { PAGINATION_LIMIT, MODAL_TRANSITION_TIME } from '@/constants'
import ShowInfoDialogMixin, { IShowDialogMixin } from '@/mixins/ShowInfoDialog.mixin'
import ViewSearchMixin, { IViewSearchMixin } from '@/mixins/ViewSearch.mixin'
import { IUser, ISimpleInvite } from '@/types/models/user.model'
import { IPagination } from '@/types/api'
import { IConnSearchField } from '@/types/filters'
import { ConnsListName } from '@/store/connections'
import ReferContactRewardsDialog from '@/components/rewards/ReferContactRewardsDialog.vue'
import { Route } from 'vue-router'
import { waitAsync } from '@/utils/common'
import { trackConnectionsScreenTab, trackConnectionsPageScroll, trackInviteToNetworkBtnTap, trackConnectionProfileTap } from '@/segmentAnalytics/connections'
import { trackHelpBtnTap } from '@/segmentAnalytics/common'

const ViewMixins = Mixins(ShowInfoDialogMixin, ViewSearchMixin)
@Component({
  components: {
    MyConnections,
    SearchField,
    listConnections,
    addConnection,
    UserProfileDialog,
    InfoIcon,
    InfoDialog,
    ReferContactRewardsDialog,
    LegacyPageContent
  },
  computed: {
    ...mapGetters([
      'profileID',
      'isAdmin',
      'isInsider',
      'isMember',
      'connections',
      'users',
      'incomingInvites',
      'connectionsTotal',
      'usersTotal',
      'incomingInvitesTotal',
      'invites',
      'canSeeUsersNetwork'
    ]),
  }
})
export default class Connections extends ViewMixins implements IShowDialogMixin, IViewSearchMixin {
  @Prop() hasProfile: boolean

  // data
  pageName: string = 'connections'
  routeName: string = 'connections'
  activeTab: string = 'connections'
  searchField: {
    [ConnsListName.connections]: IConnSearchField
    [ConnsListName.users]: IConnSearchField
    [ConnsListName.incomingInvites]: IConnSearchField
  } = {
    connections: {
      name: ''
    },
    users: {
      name: ''
    },
    incomingInvites: {
      name: ''
    }
  }
  pagination: any = {
    connections: {
      isFetching: false,
      page: 0,
    },
    incomingInvites: {
      isFetching: false,
      page: 0
    },
    users: {
      isFetching: false,
      page: 0
    }
  }
  addConnectionDialog: boolean = false
  viewProfileDialog: boolean = false
  selectedUser: IUser|null = null
  showInfoDialog: boolean = false
  showReferContactDialog: boolean = false
  handleScrollDebounced: IDebouncedFunction

  // computed
  profileID?: number
  isAdmin: boolean
  isInsider: boolean
  isMember: boolean
  connections: IUser[]
  users: IUser[]
  incomingInvites: IUser[]
  connectionsTotal: number
  usersTotal: number
  incomingInvitesTotal: number
  invites: ISimpleInvite[]
  canSeeUsersNetwork: boolean

  // lifecycle hools
  async created () {
    this.handleScrollDebounced = debounce(this.handlePageScroll, 1000)
    window.addEventListener('scroll', this.handleScrollDebounced)

    if (this.$route.params.id) {
      await this.showViewProfileDialog(+this.$route.params.id)
      await waitAsync(MODAL_TRANSITION_TIME)
    }

    if (this.canSeeUsersNetwork) {
      await this.$store.dispatch('listUsers')
    } else {
      await this.$store.dispatch('getAllUsersNumber')
    }
    // this.$store.dispatch('listUsers')
    await this.$store.dispatch('listConnections')
    await this.$store.dispatch('listIncomingInvites')
    await this.$store.dispatch('fetchAchievements')
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScrollDebounced)
  }

  // https://router.vuejs.org/guide/advanced/navigation-guards.html#in-component-guards
  async beforeRouteUpdate (to: Route, from: Route, next: Function) {
    if (to.params.id) {
      await this.showViewProfileDialog(+to.params.id)
    } else {
      this.hideViewProfileDialog()
    }
    next()
  }

  // methods
  private async showViewProfileDialog (userId: number) {
    if (!userId) return
    this.selectedUser = await this.$store.dispatch('getUser', userId)
    if (!this.selectedUser) {
      this.routeBackToConnectionsPage()
      return
    }
    this.viewProfileDialog = true
  }

  private hideViewProfileDialog () {
    this.viewProfileDialog = false
  }

  private createInvite (inviteId: number) {
    this.$store.dispatch('sendInvite', inviteId)
  }

  private acceptInvite (userId: number) {
    this.$store.dispatch('acceptInvite',this.getInvite({ from: userId, to: this.profileID }))
  }

  private declineInvite (userId: number) {
    this.$store.dispatch('declineInvite', this.getInvite({ from: userId, to: this.profileID }))
  }

  private getInvite ({ from, to }: { from: number, to?: number }): ISimpleInvite|undefined {
    return this.invites?.find((invite: ISimpleInvite) => invite.to === to && invite.from === from)
  }

  private handleInviteToNetworkClick () {
    trackInviteToNetworkBtnTap()
    this.addConnectionDialog = true
  }

  protected routeToViewProfileDialog (userId: number) {
    this.$router.push({ name: this.routeName, params: { 'id': `${userId}` } })
  }

  protected routeBackToConnectionsPage () {
    this.$router.push({ name: this.routeName })
  }

  private async handleFetchMore (listName: ConnsListName, pagination: IPagination) {
    this.fetchData(listName, pagination)
  }

  private async handleSearch (listName: ConnsListName, search: IConnSearchField) {
    this.fetchData(listName, { page: 0, limit: PAGINATION_LIMIT })
  }

  private handleHideViewProfileDialog () {
    this.routeBackToConnectionsPage()
  }

  private handleTabsChange (tab: string) {
    trackConnectionsScreenTab(tab)
  }

  private handleShowViewProfileDialog (userId: number) {
    if (this.activeTab === 'connections') {
      trackConnectionProfileTap()
    }
    this.routeToViewProfileDialog(userId)
  }

  private handlePageScroll () {
    trackConnectionsPageScroll(this.activeTab)
  }

  private handleInfoIconClick () {
    trackHelpBtnTap('connections')
    this.showInfoDialog = true
  }

  getActionByListName (listName: ConnsListName): string|undefined {
    let requestAction
    switch (listName) {
    case 'users':
      requestAction = 'listUsers'
      break
    case 'connections':
      requestAction = 'listConnections'
      break
    case 'incomingInvites':
      requestAction = 'listIncomingInvites'
      break
    }
    if (!requestAction) {
      console.warn('RequestAction is not found!', listName)
    }
    return requestAction
  }

  isSearching (listName: ConnsListName): boolean {
    return !!this.searchField[listName].name
  }
}
</script>
<style lang="scss">
.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev{display: none !important}
</style>

<style lang="scss" scoped>
  .member-warning-wrap {
    max-width: 650px;
    margin: 0 auto;
  }
</style>
